class NoteRulePresenter {
  constructor(data) {
    this.instruction = data.instruction;
    this.uuid = data.uuid;
  }

  getUUID() {
    return this.uuid;
  }

  getInstruction() {
    return this.instruction;
  }
}

export default NoteRulePresenter; 